import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { DataService } from 'src/app/services/data.service';

import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-variants-edit',
  templateUrl: './variants-edit.component.html',
  styleUrls: ['./variants-edit.component.scss','../dynamic-form/dynamic-form.component.scss'],
})
export class VariantsEditComponent implements OnInit {
  @Input() product_info ;
  @Input() current_value;
  attribute_form;
  myform;
  // list:any=[];
  // product ;
  constructor(public db:DataService,private formBuilder:FormBuilder,public modalCtrl:ModalController) { }


  ngOnInit() {
    // this.product = this.product_info
    console.log(this.product_info)

    // let v = {}

    // this.form_data.map(res =>{
    //   res.group_fileds.map(op =>{
    //     v[op.name] = new FormControl( op.value ,[])
    //   })
    // })

    // this.myform =  this.formBuilder.group(v)
  }

  // ngAfterViewInit(){
    // console.log("after view init")
    // this.load_product_Values();
  // }

  
  // load_product_Values(data){
  //     Object.keys(this.myform.controls).forEach(key => {
  //       // console.log(key,this.product_info.product_variant)  
  //       this.myform.get(key).setValue(data[key])
  //     });
  //  }

  current_variant ;
   load_values(data){
    //  this.myform.valueChanges.subscribe(x => {
    //   console.log('form value changed',x)
    // })
     this.current_variant = data
    //  this.load_product_Values(data)
      // this.form_data[0].group_fileds.map(res =>{
      //   res.value = data[res.name] 
      // })
   }

  save_value(){
    console.log(this.myform.value)
  }
  
  form_data:any =  [
    {
      group_title : 'VARIANT DETAIL',
      mapped_by: 'variant_detail',
      group_fileds : [
            {
              label :'Product Title',
              input_type: 'input',
              type : 'text',
              name :'product_title',
              placeholder : '',
              required : true,
              hidden: false,
              value : '',
            },
            {
              label :'Stock',
              input_type: 'input',
              type : 'text',
              name : 'stock',
              placeholder : '',
              required : true,
              hidden: false,
              value : '',
            },
            {
              label :'SKU',
              input_type: 'input',
              type : 'text',
              name :'sku',
              placeholder : '',
              required : false,
              hidden: false,
              value : ''
            },
            {
              label :'Price',
              input_type: 'input',
              type : 'text',
              name :'price',
              placeholder : '',
              required : true,
              hidden: false,
              value : '',
            },
            {
              label :'Weight(in gram)',
              input_type: 'input',
              type : 'text',
              name : 'weight',
              placeholder : '',
              required : true,
              hidden: false,
              value : '',
            }
      ]
    },
  ]
}
